<template>
  <!-- partner, complex, user -->
  <div v-if="isAdmin || isHomenetDev" class="residentTop">
    <div v-bind:class="topDivClass">
      <div class="columns">
        <!-- Partner -->
        <div v-if="isAdmin" class="column is-narrow">
          <label class="label">Partner:</label>
        </div>
        <div v-if="isAdmin" class="column is-narrow">
          <div class="select">
            <select v-model="selectedPartner" @change="partnerChanged">
              <option v-for="p in partnerList" :value="p">{{p}}</option>
            </select>
          </div>
        </div>
        <!-- Complex -->
        <div v-if="(isAdmin || isHomenetDev) && complexVisible" class="column is-narrow">
          <label class="label">Complex:</label>
        </div>
        <div v-if="(isAdmin || isHomenetDev) && complexVisible" class="column is-narrow">
          <div class="select">
            <select v-model="selectedComplex" @change="complexChanged">
              <option v-for="c in complexList" :value="c">{{c}}</option>
            </select>
          </div>
        </div>
        <!-- Building -->
        <div v-if="(isAdmin || isHomenetDev) && buildingVisible" class="column is-narrow">
          <label class="label">Building:</label>
        </div>
        <div v-if="(isAdmin || isHomenetDev) && buildingVisible" class="column is-narrow">
          <div class="select">
            <select v-model="selectedBuilding" @change="buildingChanged">
              <option v-for="b in buildingList" :value="b">{{b.name}}</option>
            </select>
          </div>
        </div>
        <!-- House -->
        <div v-if="(isAdmin || isHomenetDev) && houseVisible" class="column is-narrow">
          <label class="label">House:</label>
        </div>
        <div v-if="(isAdmin || isHomenetDev) && houseVisible" class="column is-narrow">
          <div class="select">
            <select v-model="selectedHouse" @change="houseChanged">
              <option v-for="h in houseList" :value="h">{{h.name}}</option>
            </select>
          </div>
        </div>
        <!-- User -->
        <div v-if="(isAdmin || isHomenetDev) && userVisible" class="column is-narrow">
          <label class="label">User:</label>
        </div>
        <div v-if="(isAdmin || isHomenetDev) && userVisible" class="column is-narrow">
          <div class="select">
            <select v-model="selectedUser" @change="userChanged">
              <option v-for="u in userList" :value="u">{{u}}</option>
            </select>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import util from 'util'
import Vue from 'vue'
import myUtil from '../lib/utils'

var config = {
  headers: {
    'Content-Type': 'application/json; charset=utf-8'
  }
}

export default {
  props: {
    topDivClass: {
      type: String,
      default: 'box'
    },
    complexVisible: {
      type: Boolean,
      default: true
    },
    buildingVisible: {
      type: Boolean,
      default: true
    },
    houseVisible: {
      type: Boolean,
      default: true
    },
    userVisible: {
      type: Boolean,
      default: false
    },
    getServerData: {
      type: Boolean,
      default: false
    }
  },

  data () {
    return {
      isAdmin: false,
      isHomenetDev: false,
      partnerList: [],
      selectedPartner: null,
      complexList: [],
      selectedComplex: null,
      buildingList: [],
      selectedBuilding: null,
      houseList: [],
      selectedHouse: null,
      userList: [],
      selectedUser: null
    }
  },

  mounted () {
    this.isAdmin = myUtil.isGroupMember(this, 'admin')
    this.isHomenetDev = myUtil.isGroupMember(this, 'homenet-dev')
    if (this.getServerData) {
      if (this.isAdmin) {
        this.getPartnerList()
      } else if (this.isHomenetDev) {
        this.getMyPartner()
      } else {
        window.addEventListener('auth-token-localstorage-changed', (event) => {
          console.log('Auth token on local storage got changed')
          this.isHomenetDev = myUtil.isGroupMember(this, 'homenet-dev')
          this.isAdmin = myUtil.isGroupMember(this, 'admin')
          if (this.isAdmin) {
            this.getPartnerList()
          } else if (this.isHomenetDev) {
            this.getMyPartner()
          }
        })
      }
    } else {
      this.$nextTick(() => {
        this.getLocalData()
      })
    }
  },

  methods: {
    getLocalData () {
      console.log('get local data')
      let username = ''
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-'
      }
      let localPartnerList = window.localStorage.getItem(username + 'partnerList')
      if (localPartnerList) {
        this.partnerList = localPartnerList.split(',')
      } else {
        this.partnerList = []
      }
      this.selectedPartner = window.localStorage.getItem(username + 'selectedPartner')
      this.$emit('partnerChanged')

      let localComplexList = window.localStorage.getItem(username + 'complexList')
      if (localComplexList) {
        this.complexList = localComplexList.split(',')
      } else {
        this.complexList = []
      }
      this.selectedComplex = window.localStorage.getItem(username + 'selectedComplex')
      this.$emit('complexChanged')

      let localBuildingList = window.localStorage.getItem(username + 'buildingList')
      if (localPartnerList) {
        this.buildingList = JSON.parse(localBuildingList)
      } else {
        this.buildingList = []
      }
      this.selectedBuilding = JSON.parse(window.localStorage.getItem(username + 'selectedBuilding'))
      this.$emit('buildingChanged')

      let localHouseList = window.localStorage.getItem(username + 'houseList')
      if (localHouseList) {
        this.houseList = JSON.parse(localHouseList)
      } else {
        this.houseList = []
      }
      this.selectedHouse = JSON.parse(window.localStorage.getItem(username + 'selectedHouse'))
      this.$emit('houseChanged')

      this.userList = window.localStorage.getItem(username + 'userList')
      this.selectedUser = window.localStorage.getItem(username + 'selectedUser')
      this.$emit('userChanged')
    },
    getSelectedItem (array, localKey, compareKey) {
      if (!array || array.length === 0) {
        return null
      }
      let username = ''
      if (this.$auth.watch && this.$auth.watch.data && this.$auth.watch.data.username) {
        username = this.$auth.watch.data.username + '-'
      }
      let localData = window.localStorage.getItem(username + localKey)
      if (!localData) {
        return array[0]
      }
      try {
        let parsedData = JSON.parse(localData)
        localData = parsedData
      } catch (err) {
      }
      if (array.indexOf(localData) >= 0) {
        return localData
      }
      if (compareKey) {
        for (let item of array) {
          if (item[compareKey] === localData[compareKey]) {
            return item
          }
        }
      }
      return array[0]
    },
    getPartnerList () {
      this.partnerList = []
      this.selectedPartner = null
      this.complexList = []
      this.selectedComplex = null
      this.buildingList = []
      this.selectedBuilding = null
      this.houseList = []
      this.selectedHouse = null
      this.userList = []
      this.selectedUser = null
      let url = this.$store.state.api.residentPartner
      console.log('partner list url: ' + Vue.axios.defaults.baseURL + url)
      this.$http
        .get(url, config)
        .then(response => {
          if (response.data) {
            response.data.forEach(partner => {
              this.partnerList.push(partner.name)
            })
          }
          console.log('get partner data: ', myUtil.jsonpretty(response.data))
          if (this.partnerList.length > 0) {
            this.selectedPartner = this.getSelectedItem(this.partnerList, 'selectedPartner')
          }
          if (this.selectedPartner) {
            this.$emit('partnerChanged')
            this.getComplexList()
          }
        })
        .catch(error => {
          console.log(util.inspect(error))
        })
    },
    getMyPartner () {
      this.partnerList = []
      this.selectedPartner = null
      this.complexList = []
      this.selectedComplex = null
      this.buildingList = []
      this.selectedBuilding = null
      this.houseList = []
      this.selectedHouse = null
      this.userList = []
      this.selectedUser = null
      let url = this.$store.state.api.residentPartner + '/my'
      console.log('my parter url: ' + Vue.axios.defaults.baseURL + url)
      this.$http
        .get(url, config)
        .then(response => {
          if (response.data) {
            response.data.forEach(partner => {
              this.partnerList.push(partner.name)
            })
          }
          console.log('get partner data: ', myUtil.jsonpretty(response.data))
          if (this.partnerList.length > 0) {
            this.selectedPartner = this.getSelectedItem(this.partnerList, 'selectedPartner')
            this.$emit('partnerChanged')
          }
          if (this.selectedPartner) this.getComplexList()
        })
        .catch(error => {
          console.log(util.inspect(error))
        })
    },
    partnerChanged () {
      this.$emit('partnerChanged')
      this.getComplexList()
    },
    getComplexList () {
      this.complexList = []
      this.selectedComplex = null
      this.buildingList = []
      this.selectedBuilding = null
      this.houseList = []
      this.selectedHouse = null
      this.userList = []
      this.selectedUser = null
      let url = this.$store.state.api.residentComplex + '/' + this.selectedPartner
      this.$http
        .get(url, config)
        .then(response => {
          if (response.data) {
            this.complexList = response.data
          }
          if (this.complexList && this.complexList.length > 0) {
            this.selectedComplex = this.getSelectedItem(this.complexList, 'selectedComplex')
            this.$emit('complexChanged')
            this.getComplexDetail()
          }
        })
        .catch(error => {
          console.log(util.inspect(error))
        })
    },
    getComplexDetail () {
      this.buildingList = []
      this.selectedBuilding = null
      this.houseList = []
      this.selectedHouse = null
      this.userList = []
      this.selectedUser = null
      let url = this.$store.state.api.residentComplex +
        '/' + this.selectedPartner + '/' + this.selectedComplex
      this.$http
        .get(url, config)
        .then(response => {
          if (response.data) {
            console.log('get complex detail:', myUtil.jsonpretty(response.data))
            let buildingChangedEmit = false
            let houseChangedEmit = false
            let userChangedEmit = false
            response.data.buildings.forEach(bld => {
              this.buildingList.push(bld)
            })
            this.selectedBuilding = this.getSelectedItem(this.buildingList, 'selectedBuilding', 'name')
            if (this.selectedBuilding) {
              buildingChangedEmit = true
              this.selectedBuilding.houses.forEach(house => {
                this.houseList.push(house)
              })
              this.selectedHouse = this.getSelectedItem(this.houseList, 'selectedHouse', 'name')
              houseChangedEmit = true
              if (this.selectedHouse) {
                this.selectedHouse.residents.forEach(user => {
                  this.userList.push(user.Username)
                })
                this.selectedUser = this.getSelectedItem(this.userList, 'selectedUser')
                userChangedEmit = true
              }
            }
            if (buildingChangedEmit) {
              this.$emit('buildingChanged')
            }
            if (houseChangedEmit) {
              this.$emit('houseChanged')
            }
            if (userChangedEmit) {
              this.$emit('userChanged')
            }
          }
        })
        .catch(error => {
          console.log(util.inspect(error))
        })
    },
    complexChanged () {
      this.$emit('complexChanged')
      this.getComplexDetail()
    },
    buildingChanged () {
      this.$emit('buildingChanged')
      this.houseList = []
      this.selectedHouse = null
      this.userList = []
      this.selectedUser = null
      let houseChangedEmit = false
      let userChangedEmit = false
      if (this.selectedBuilding) {
        this.selectedBuilding.houses.forEach(house => {
          this.houseList.push(house)
        })
        this.selectedHouse = this.getSelectedItem(this.houseList, 'selectedHouse', 'name')
        if (this.selectedHouse) {
          this.selectedHouse.residents.forEach(user => {
            this.userList.push(user.Username)
          })
          if (this.userList.length > 0) {
            this.selectedUser = this.getSelectedItem(this.userList, 'selectedUser')
            userChangedEmit = true
          }
        }
        if (houseChangedEmit) {
          this.$emit('houseChanged')
        }
        if (userChangedEmit) {
          this.$emit('userChanged')
        }
      }
    },
    houseChanged () {
      console.log('House got changed')
      this.$emit('houseChanged')
      this.userList = []
      this.selectedUser = null
      if (this.selectedHouse) {
        this.selectedHouse.residents.forEach(user => {
          this.userList.push(user.Username)
        })
      }
      if (this.userList.length > 0) {
        this.selectedUser = this.getSelectedItem(this.userList, 'selectedUser')
        this.$emit('userChanged')
      }
    },
    userChanged () {
      this.$emit('userChanged')
    }
  }
}
</script>

<style>
  .residentTop {
    margin-bottom: 10px;
  }
</style>



// WEBPACK FOOTER //
// Resident.vue?b941f3ea